import { render, staticRenderFns } from "./EditPartyDetailsFooter.vue?vue&type=template&id=059aaeb8"
import script from "./EditPartyDetailsFooter.vue?vue&type=script&lang=js"
export * from "./EditPartyDetailsFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports